export const PromotionAction = (json: IDiscountPromotionAction): IDiscountPromotionActionModel => {
	const fromJSON = () => {
		const { ...rest } = json
		return {
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const promotionActionToJSON = (
	obj: Partial<IDiscountPromotionActionModel>,
): Partial<IDiscountPromotionAction> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}

/**
 * Payloads
 */
const PromotionActionPayloadShared = (
	event: IFormSubmitEvent<IDiscountPromotionActionFormData>,
): IDiscountPromotionActionPayloadShared => {
	const { type, amount } = event.values

	const configurationFieldName = {
		[EPromotionType.FIXED]: 'amount',
		[EPromotionType.PERCENTAGE]: 'percent',
	}
	const resolveConfigurationValue = () => {
		if (amount === null || Number.isNaN(amount)) return undefined
		if (type === EPromotionType.FIXED) return PriceToPayload(amount) ?? undefined
		return amount
	}
	const configuration: IDiscountPromotionActionPayloadConfiguration = {
		[configurationFieldName[type]]: resolveConfigurationValue(),
	}

	return {
		type,
		configuration,
	}
}

export const PromotionActionCreatePayload = (
	event: IFormSubmitEvent<IDiscountPromotionActionFormData>,
): IDiscountPromotionActionCreatePayload => {
	const shared = PromotionActionPayloadShared(event)

	return {
		...shared,
	}
}

export const PromotionActionUpdatePayload = (
	event: IFormSubmitEvent<IDiscountPromotionActionFormData>,
): IDiscountPromotionActionUpdatePayload => {
	const shared = PromotionActionPayloadShared(event)

	return {
		...shared,
	}
}
